import { render, staticRenderFns } from "./TableLastUpdate.vue?vue&type=template&id=4b63a448&scoped=true"
import script from "./TableLastUpdate.vue?vue&type=script&lang=ts"
export * from "./TableLastUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63a448",
  null
  
)

export default component.exports